var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"income"},[_c('v-container',{staticClass:"px-0",class:_vm.isPrinting? 'py-0' : '',staticStyle:{"max-width":"800px"}},[_c('ProfitAndLoss',{attrs:{"fill-width":"","pid":_vm.pid}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }